import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Divider,
	Typography,
	useTheme,
} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import Icon from 'presentation/icons';
import React from 'react';
import {RenderBeneficiaries} from './RenderBeneficiaries';
import {RenderBeneficiariesProps} from './types';
import {useMediaQueries} from 'presentation/pages/private';
import {translations} from 'presentation/translations-new';

const {inactiveBeneficiaries} = translations['pt-br'].commons;

export const InactiveBeneficiariesAccordion = ({
	list,
	isCompareSelectedBeneficiary,
	handleSelectBeneficiary,
	hasOnlyCanceled,
}: RenderBeneficiariesProps) => {
	const {palette} = useTheme();
	const {isTablet} = useMediaQueries();

	if (!list?.length) return null;

	return (
		<StyledGrid.Item xs={12}>
			{!hasOnlyCanceled ? <Divider sx={{mb: isTablet ? 2 : 3}} /> : null}
			<Accordion defaultExpanded={hasOnlyCanceled} elevation={0}>
				<AccordionSummary
					expandIcon={
						<Icon name="expand-more-filled" color={palette.primary.main} size={20} />
					}>
					<Typography variant="body2" color="text.secondary" fontWeight={600}>
						{inactiveBeneficiaries}
					</Typography>
				</AccordionSummary>

				<AccordionDetails>
					<StyledGrid.Root spacing={1}>
						<RenderBeneficiaries
							list={list}
							isCompareSelectedBeneficiary={isCompareSelectedBeneficiary}
							handleSelectBeneficiary={handleSelectBeneficiary}
							hasOnlyCanceled={hasOnlyCanceled}
						/>
					</StyledGrid.Root>
				</AccordionDetails>
			</Accordion>
		</StyledGrid.Item>
	);
};
